define('helpers/viewHelpers',['require','exports','module','accounting','env'],function (require, exports, module) {
  'use strict';

  var accounting = require('accounting'),
      Config = require('env');

  var viewHelpers = {
    COOKIE_EXPIRATION_DAYS: 365,

    formatNumber: function (number) {
      return accounting.formatNumber(number, 0, '.');
    },
    // This seems wrong to me (pin) but i'm scared to touch anything
    // as this function is used widely, created a new one below.
    formatNumberWithTwoDecimals: function (number) {
      return accounting.formatNumber(number, 2, '.', '','');
    },

    formatFractionalNumber: function (number) {
      return accounting.formatNumber(number, 2, '.', ',');
    },

    nFormatter: function (num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' B';
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + ' M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
      }
      return num;
    },

    getPercent: function (num, max) {
      if (max === 0) {
        return 0;
      }
      return Math.round((num / max) * 100);
    },

    isEmptyDate: function(dateString) {
      return !dateString || dateString === '0000-00-00 00:00:00';
    },

    getDateWithoutTime: function(dateString) {
      return dateString.slice(0, 10);
    },

    getDaysToExpirationByEndDate: function (endDate) {
      // endDate format; 2014-12-03 10:42:06
      var now = new Date(),
          daysToExpiration = 0;
      if (endDate) {
        endDate = new Date(endDate.replace(' ', 'T'));
        daysToExpiration = Math.ceil(((endDate - now) / (1000 * 60 * 60 * 24)));
        if (daysToExpiration < 0) {
          daysToExpiration = 0;
        }
      }
      return daysToExpiration;
    },

    getCurrencySymbol: function (currencyCode) {
      var currency_symbols = {
        'USD': '$', // US Dollar
        'EUR': '€', // Euro
        'BRL': 'R$', // Brazil Real
        'ARS': '$', // Argentina Peso
        'CRC': '₡', // Costa Rican Colón
        'GBP': '£', // British Pound Sterling
        'ILS': '₪', // Israeli New Sheqel
        'INR': '₹', // Indian Rupee
        'JPY': '¥', // Japanese Yen
        'KRW': '₩', // South Korean Won
        'NGN': '₦', // Nigerian Naira
        'PHP': '₱', // Philippine Peso
        'PLN': 'zł', // Polish Zloty
        'PYG': '₲', // Paraguayan Guarani
        'THB': '฿', // Thai Baht
        'UAH': '₴', // Ukrainian Hryvnia
        'VND': '₫' // Vietnamese Dong
      };

      var symbol = '';

      if (currency_symbols.hasOwnProperty(currencyCode)) {
        symbol = currency_symbols[currencyCode];
      }

      return symbol;
    },

    buildCookieExpirationDate: function (cookieExpirationDays) {
      if (!cookieExpirationDays) {
        cookieExpirationDays = this.COOKIE_EXPIRATION_DAYS;
      }

      var d = new Date();
      d.setTime(d.getTime() + (cookieExpirationDays * 24 * 60 * 60 * 1000));

      return 'expires=' + d.toUTCString();
    },

    setCookie: function (cookieName, cookieValue, cookieExpirationDays) {
      if (!cookieName || !cookieValue) {
        return false;
      }

      var cookieExpirationDate = this.buildCookieExpirationDate(cookieExpirationDays);

      document.cookie = cookieName + '=' + cookieValue + ';' +
          cookieExpirationDate + '; path=/;Domain=' + Config.i18nCookieDomain +
          '; samesite=strict; Secure;';
    }
  };

  module.exports = viewHelpers;
});

